import { render, staticRenderFns } from "./Popularity.vue?vue&type=template&id=5d9cd062&%23Popularity=true"
import script from "./Popularity.vue?vue&type=script&lang=js"
export * from "./Popularity.vue?vue&type=script&lang=js"
import style0 from "./Popularity.vue?vue&type=style&index=0&id=5d9cd062&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports